import { Injectable, TemplateRef } from '@angular/core';
import { MenuItem } from '@app/shared/models/menu.interface';
import { Store } from '@app/shared/store/store';

export interface MainBarState {
  back?: string[];
  backState: { [k: string]: any };
  icon: string;
  title: string;
}

export interface MenuState {
  expanded: boolean;
  items: MenuItem[];
}

export interface SidenavState {
  opened: boolean;
  template: TemplateRef<any>;
  disableClose?: boolean;
  panelClass?: string;
  meta?: any;
}

export interface ContentContainerState {
  mainBar: MainBarState;
  menu: MenuState;
  sidenav: SidenavState;
}

const initialState: ContentContainerState = {
  mainBar: {
    back: [],
    backState: null,
    icon: '',
    title: ''
  },
  menu: {
    expanded: false,
    items: []
  },
  sidenav: {
    opened: false,
    template: null,
    disableClose: false
  }
};

@Injectable()
export class ContentContainerStore extends Store<ContentContainerState> {
  constructor() {
    super(initialState);
  }

  get mainBarState(): MainBarState {
    return this.state.mainBar;
  }

  set mainBarState(next: MainBarState) {
    this.state = { ...this.state, mainBar: next };
  }

  get menuState(): MenuState {
    return this.state.menu;
  }

  set menuState(next: MenuState) {
    this.state = { ...this.state, menu: next };
  }

  get sidenavState(): SidenavState {
    return this.state.sidenav;
  }

  set sidenavState(sidenav: SidenavState) {
    this.state = { ...this.state, sidenav };
  }

  setBack(next: string[]): void {
    this.mainBarState = { ...this.mainBarState, back: next };
  }

  setBackState(next: { [k: string]: any }): void {
    this.mainBarState = { ...this.mainBarState, backState: next };
  }

  setIcon(next: string): void {
    this.mainBarState = { ...this.mainBarState, icon: next };
  }

  setTitle(next: string): void {
    this.mainBarState = { ...this.mainBarState, title: next };
  }

  setMenuExpanded(expanded: boolean): void {
    this.menuState = { ...this.menuState, expanded };
  }

  setMenuItems(newItems: MenuItem[]): void {
    this.menuState = { ...this.menuState, items: newItems };
  }

  toggleMenu(): void {
    this.setMenuExpanded(!this.menuState.expanded);
  }
}
